import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { classNameStrings } from '../../../../constants/base';
import Car from './car';
import CarBox from './carBox';

function StatisticsNFTMain() {
  // -- props --//

  // -- component const --//
  const title = 'NFT'

  // -- useSelector & dispatch --//

  // -- state --//
  const [className, setClassName] = useState('tab1');

  // -- func & handler --//

  // -- react hooks --//

  // -- render --//

  return (
    <div className='page over'>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="topSection flowRoot">
        <div className="leftSection">
          <p className="titleText">
            {title}
          </p>
        </div>

        <div className="rightSection">
          <button
            className={className === 'tab1' ? 'tab1 active' : 'tab1'}
            onClick={() => setClassName('tab1')}
          >
            차량
          </button>
          <button
            className={
              className === 'tab2' ? 'tab2 active' : 'tab2'
            }
            onClick={() => setClassName('tab2')}
          >
            차량 상자
          </button>
        </div>
      </div>

      <div className="spaceDiv10"/>

      <div className="divTaps">
        {className === 'tab1' && <Car />}
        {className === 'tab2' && <CarBox />}
      </div>
    </div>
  );
}

export default StatisticsNFTMain;
